<template>
  <main>
    <div class="header"></div>
    <div class="wrapper">
      <div class="wrapper-center">
        <div class="t-left card2">
          <div>
            <imgexpand src='assets/drawing4.jpg' title="Plebeyos y Ave"/>
          </div>
        </div>
        <div class="center card2">
          <div>
            <div class="center-wrapper">
              <div class="center-image">
                 <imgexpand src='assets/drawing6.jpg' title="El Rescate"/>
              </div>
              <div class="center-name">
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="t-right card2">
          <div>
             <imgexpand src='assets/drawing2.jpg' title="Ave (paloma)"/>
          </div>
        </div>
        <div class="b-left card2">
          <div>
             <imgexpand src='assets/drawing5.jpg' title="Oscuro"/>
          </div>
        </div>
        <div class="pluma2 card2">
          <div>
             <imgexpand src='assets/pluma2.jpg' title="Pluma"/>
          </div>
        </div>
        <div class="b-right card2">
          <div>
             <imgexpand src='assets/drawing3.jpg' title="Anter el Rey"/>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import imgexpand from "./imgexpand.vue";
import { expand } from "./expand.js";

export default {
  components: {
    imgexpand
  },
  methods: {
    test(val) {
      expand(val);
    }
  }
};
</script>

<style >

/* @import url("expand.css"); */
/* * {
  border: 1px solid black;
} */
main {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
main > div {
  width: 100%;
}
.header {
  height: 15px;
  background: #ececec;
}
.wrapper {
  max-width: 1000px;
  flex-grow: 1;
}
.wrapper-center {
  height: 90%;
  padding-left: 25px;
  padding-right: 25px;
  margin-top: 20px;
  display: grid;
  gap: 35px;
  grid-template-rows: 46% auto 25%;
  grid-template-columns: 25% auto 25%;
}

.t-left {
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
}
.center {
  grid-column: 2 / span 1;
  grid-row: 1 / span 2;
}
.b-left {
  grid-column: 1 / span 1;
  grid-row: 2 / span 2;
}
.b-right {
  grid-column: 3 / span 1;
  grid-row: 2 / span 2;
}
.pluma2 {
  grid-column: 2 / span 1;
  grid-row: 3 / span 1;
}
.wrapper-center > div {
  position: relative;
}
.wrapper-center > div > div {
  /* border: 5px solid black; */
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.t-left > div,
.t-right > div {
  border: 3px solid rgb(31, 31, 31);
}
.b-left > div,
.b-right > div,
.pluma2 {
  border: 5px solid rgb(31, 31, 31);
}
.center {
  border: 10px solid rgb(31, 31, 31);
}

.center-wrapper {
  height: 100%;
  display: grid;
  grid-template-rows: 60% auto;
}

.center-image {
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
}
.center-image > div {
  overflow: hidden;
  background-size: cover;
  background-position: top;
  height: 100%;
  background-image: url("../assets/drawing6.jpg");
}
.ima {
  background-color: red;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center top;
}
.center-name {
  font-family: "Source Serif Pro", serif;

  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.center-name > div {
  background-size: 100% 100%;

  background-image: url("../assets/Group.png");
  height: 100%;
}

@keyframes cardEntrance {
  from {
    opacity: 0;
    transform: scale(0.3);
    filter: hue-rotate(180deg);
  }
  to {
    opacity: 1;
    transform: scale(1);
    filter: hue-rotate(0deg);
  }
}
.card2 {
  animation: cardEntrance 700ms ease-out;
  animation-fill-mode: backwards;
}

.wrapper-center{
  --stagger-delay: 100ms;
}
.card2:nth-child(1){ /**t-left */
  animation-delay: calc(6 * var(--stagger-delay));
}
.card2:nth-child(2){ /* center */
  animation-delay: calc(1 * var(--stagger-delay));
}
.card2:nth-child(3){ /* t-right*/ 
  animation-delay: calc(2 * var(--stagger-delay));
}
.card2:nth-child(4){ /* b-left */ 
  animation-delay: calc(5 * var(--stagger-delay));
}
.card2:nth-child(5){ /* pluma */ 
  animation-delay: calc(4 * var(--stagger-delay));
}
.card2:nth-child(6){ /* b-right */ 
  animation-delay: calc(3 * var(--stagger-delay));
}
</style>